import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import { LiveFeedRepository } from "app/js/src/domain/live-feed-repository";
import { LiveFeedPreview } from "app/js/src/domain/live-feed-preview";
import { WebRTCPreview } from "app/js/src/domain/web-r-t-c-preview";
import { TenantSettingsRepository } from "../../../domain/tenant-settings-repository";
import { UserService } from "../../../domain/user-service";

@Component({
  selector: "icn-live-feed-preview",
  templateUrl: "./live-feed-preview.component.html",
  styleUrls: ["./live-feed-preview.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveFeedPreviewComponent implements OnInit, OnDestroy {
  @Input()
  liveFeedPreview: LiveFeedPreview;

  @Input()
  availabilityZones: number[] = [];
  previewUrl: string;
  selectedAvailabilityZoneId: number;
  feedPreviewPingInterval: any;
  webrtcPreviewData: WebRTCPreview;

  constructor(
    private liveFeedRepository: LiveFeedRepository,
    private _tenantSettingsRepository: TenantSettingsRepository,
    private _userService: UserService,
  ) {}

  async ngOnInit() {
    const currentUser = this._userService.getCurrentUser();
    //const tenantSettings = await this._tenantSettingsRepository.getTenantSettings();

    this.selectedAvailabilityZoneId =
      this.liveFeedPreview.availabilityZoneUrls[
        Object.keys(this.liveFeedPreview.availabilityZoneUrls)[0]
      ].id;
    this.previewUrl =
      this.liveFeedPreview.availabilityZoneUrls[
        this.selectedAvailabilityZoneId.toString()
      ].url;
    this.webrtcPreviewData = new WebRTCPreview(
      this.liveFeedPreview.clientId,
      this.liveFeedPreview.brodcasterId,
      new Array<string>(this.previewUrl),
    );
    this.feedPreviewPingInterval = setInterval(() => {
      this.liveFeedRepository.pingLiveFeedPreview(this.liveFeedPreview.id);
    }, 10000);
  }

  ngOnDestroy() {
    if (this.feedPreviewPingInterval) {
      clearInterval(this.feedPreviewPingInterval);
      this.feedPreviewPingInterval = null;
    }
  }

  setSelectedAz(az: number) {
    this.selectedAvailabilityZoneId = az;
    this.previewUrl =
      this.liveFeedPreview.availabilityZoneUrls[
        this.selectedAvailabilityZoneId.toString()
      ].url;
    this.webrtcPreviewData.availabilityZoneUrls = new Array<string>(
      this.previewUrl,
    );
  }
}
